const images = {
  logo: require("./logo.svg").default,
  logoColored: require("./logo-colored.png").default,
  404: require("./404.png"),
  heroBg: require("./hero-bg.png"),
  videoBtn: require("./video-btn.png"),
  dot: require("./dot.png"),
  monitoring: require("./monitoring.png"),
  internet: require("./internet.png"),
  onlinebooking: require("./online-booking.png"),
  report: require("./report.png"),
  contract: require("./contract.png"),
  accounting: require("./accounting.png"),
  addashboard1: require("./addashboard1.png"),
  ad1bg: require("./ad1bg.jpg"),
  section2: require("./section2.png"),
  section3: require("./section3.png"),
  section4: require("./section4.png"),
  sectorimg: require("./sectorimg.png"),
  uygunakirala: require("./uygunakirala.png"),
  applestore: require("./app-store-btn-1.png"),
  googleplay: require("./google-play-btn-1.png"),
  capterra: require("./capterra.png"),
  pricing: require("./pricing-bg.png"),
  contact: require("./contact.svg").default,
  iyzico: require("./iyzico.svg").default,
  booqappicon: require("./booqapp.png"),
  uygunakiralaicon: require("./uygunakiralaicon.svg").default,
  uygunakiralamobil: require("./uygunakiralamobile.png"),
  avatar: require("./avatar.png"),
  logoiconcolored: require("./logo-colored.svg").default,
  checkmark: require("./checkmark.gif"),
  party: require("./party.png"),
  AssetsDashboard: require("./AssetsDashboard.png"),
};

export default images;
